module.exports = __webpack_public_path__ + "static/media/faq4.a40fd2de.webp";